export default function init() {
  const links = [...document.querySelectorAll('.js-back')];
  if (links.length) {
    links.forEach((link) => {
      link.addEventListener('click', () => {
        window.history.go(-1);
        return false;
      });
    });
  }
}
